<template>
  <el-dialog
    title="扫描二维码，开始预约"
    :visible.sync="qrCodeDialogVisible"
    width="30%" :close-on-click-modal="false" @close="qrcodeDialogCloseHandle"
    center>
    <div style="text-align: center">
      <img :src="qrCodeSrc">
      <div style="color: red;">{{errorMsg}}</div>
    </div>
  </el-dialog>
</template>
<script>
  import {generateQrcode, getOpenId} from 'src/api/qrcodeApi'
  import {getByOpenId} from 'src/api/memberApi'
  import {isNotEmpty} from 'src/utils/myUtils'
  import {showErrorMsg} from 'src/utils/dialog'

  export default {
    data () {
      return {
        qrCodeSrc: '',
        openIdInterval: null,
        errorMsg: '',
        qrCodeDialogVisible: false
      }
    },
    props: {
      closeBackToIndex: {
        default: false
      }
    },
    components: {},
    methods: {
      toGenerateQrcode () {
        generateQrcode().then((resp) => {
          this.qrCodeSrc = resp.qrcode
          this.qrCodeDialogVisible = true
          let that = this
          this.openIdInterval = setInterval(function () {
            getOpenId(resp.uuid).then((openId) => {
              if (isNotEmpty(openId)) {
                clearInterval(that.openIdInterval)
                that.onLogin(openId)
              }
            })
          }, 2000)
        })
      },
      qrcodeDialogCloseHandle () {
        if (this.openIdInterval != null) {
          clearInterval(this.openIdInterval)
        }
        if (this.closeBackToIndex) {
          this.$router.push({
            name: 'Home'
          })
        } else {
          this.qrCodeDialogVisible = false
        }
      },
      onLogin (openId) {
        getByOpenId(openId).then((memberId) => {
          if (isNotEmpty(memberId)) {
            this.$router.push({
              name: 'Appointment',
              query: {
                memberId: memberId
              }
            })
          } else {
            this.errorMsg = '此微信号尚未绑定，请去前台绑定后再预约！'
            showErrorMsg(this.errorMsg)
            this.toGenerateQrcode()
          }
        })
      },
      closeDialog () {
        this.qrCodeDialogVisible = false
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/AppoimentQrCode.vue